export default __webpack_public_path__ + "static/media/applicants.7bda4c1c.jpg";